import React from 'react'
import type { PublicProfile } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'

import {
  BodyTextBold,
  DesktopH2,
} from 'components/UI/Typography/Typography.new'
import Wrapper from 'components/Wrapper/Wrapper'

import B2BStep from './B2BStep'
import NameFlip from './NameFlip'

import styles from './B2BSteps.module.css'

type B2BStepsProps = {
  profilesList: PublicProfile[]
  color?: string
}

const B2BSteps = ({
  profilesList,
  color = '#f8284e',
}: B2BStepsProps): JSX.Element => {
  const { t } = useTranslation()
  const steps = [
    {
      step: 1,
      description: t('B2BSteps.chooseTalent', 'Choose the right talent'),
    },
    {
      step: 2,
      description: t('B2BSteps.chooseBrief', 'Create a brief in 5 minutes'),
    },
    {
      step: 3,
      description: t(
        'B2BSteps.receiveVideo',
        'Receive a personal video ready to use',
      ),
    },
  ]
  return (
    <Wrapper>
      <div className={styles.container} data-cy="B2BSteps">
        <NameFlip
          names={
            profilesList ? profilesList.map((profile) => profile.name) : []
          }
          color={color}
        />
        <div className={styles.title}>
          <DesktopH2 element="h2">
            {t('B2BSteps.talentIsReady', 'is ready to work with you')}
          </DesktopH2>
        </div>
        <div className={styles.stepsContainer}>
          {steps.map(({ step, description }) => (
            <B2BStep
              key={`steps-${step}`}
              step={step}
              description={description}
              color={color}
            />
          ))}
        </div>
        <div className={styles.byLine}>
          <BodyTextBold>
            {t('B2BSteps.thatEasy', '(yep, it’s really that easy)')}
          </BodyTextBold>
        </div>
      </div>
    </Wrapper>
  )
}

export default B2BSteps
